export const ELEVATEOS_LOGO_ALT = 'ElevateOS'
